import { createStore } from '../createStore';
import { TreeNode } from './launcherElementsStore';

export interface LauncherWindowData {
  formatVersion: string;
  windowWidth: number;
  windowHeight: number;
  isWindowResizable: boolean;
  fonts: { fontFamily: string; src: string }[];
  class: {};
  children: TreeNode[];
}

export const launcherWindowDefault: LauncherWindowData = {
  formatVersion: '2.0',
  windowWidth: 0,
  windowHeight: 0,
  isWindowResizable: false,
  fonts: [],
  class: {},
  children: [],
};

export const [LauncherWindowStoreProvider, useLauncherWindowStore] =
  createStore<LauncherWindowData>(launcherWindowDefault);
